/**
 * PageIntroGuide — the ONE shared page intro-tip rail.
 *
 * Slot ③ of the locked page-header zone (PageLayout). Always visible —
 * no toggle, no label row. The hairline left rail identifies it as a tip
 * without needing a "How X works" caption. Content is open on all
 * breakpoints by default (Peyton-locked 2026-06-13).
 *
 * One style platform-wide — never restyled per page.
 */

import { ReactNode } from 'react';

interface PageIntroGuideProps {
  /** Kept for call-site compatibility; no longer rendered. */
  label?: string;
  /** The orientation copy shown inline. */
  children: ReactNode;
}

export function PageIntroGuide({ children }: PageIntroGuideProps) {
  return (
    <div className="border-l border-[var(--hairline-strong)] pl-5 text-[13px] font-light leading-relaxed text-white/40">
      {children}
    </div>
  );
}

export default PageIntroGuide;
